import { UserRole, User } from '../types';

interface UnitMembership {
  unitId: string;
  role: UserRole;
  joinedAt: Date;
}

export function useUnitPermissions(
  userProfile: User | null,
  unitId: string | undefined
) {
  const hasPermission = (requiredRole: UserRole): boolean => {
    if (!userProfile || !unitId) return false;
    const memberships = userProfile.units || [];
    const membership = memberships?.find((m: UnitMembership) => m.unitId === unitId);
    if (!membership) return false;

    const roleHierarchy: Record<UserRole, number> = {
      Guest: 0,
      Member: 1,
      Steward: 2,
      Treasurer: 3,
      Secretary: 4,
    };

    return (
      roleHierarchy[membership.role as keyof typeof roleHierarchy] >=
      roleHierarchy[requiredRole as keyof typeof roleHierarchy]
    );
  };

  const canEdit = hasPermission('Secretary');

  return { hasPermission, canEdit };
}

